// Session storage strategy: an installed/"Add to Home Screen" app gets its OWN isolated storage
// bucket (separate from regular browser tabs and from any other installed icon of the same site),
// so it's safe to persist its login with localStorage there. Regular browser tabs keep using
// sessionStorage (each tab isolated) so the original "Tab A admin / Tab B tenant" bleed bug stays fixed.
function isStandaloneApp() {
  try {
    return (
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true
    );
  } catch (e) {
    return false;
  }
}

function activeStorage() {
  return isStandaloneApp() ? window.localStorage : window.sessionStorage;
}

export function authGetItem(key) {
  try {
    return activeStorage().getItem(key);
  } catch (e) {
    return null;
  }
}

export function authSetItem(key, value) {
  try {
    activeStorage().setItem(key, value);
  } catch (e) { /* ignore */ }
}

export function authRemoveItem(key) {
  try {
    activeStorage().removeItem(key);
  } catch (e) { /* ignore */ }
}
